import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import ReportCard from '../../components/Card/Report';
import { useEffect, useState } from 'react';
import { typeMappingHandler } from '../../constants/keysMapping';
import { useSelector } from 'react-redux';
import { userSelector } from '../../store/user/user.selector';
import './dashboard.scss';

const Dashboard = () => {
  const user = useSelector(userSelector);
  const [loading, setLoading] = useState(true);
  const [orgPersonal, setOrgPersonal] = useState([]);

  const { userCount, totalPurchasedTests, totalDoneTests, amount } = user || {};

  const calculateOrgPersonal = (userInfo) => {
    let temp = [];
    [
      'organisationName',
      'fullName',
      'activitySector',
      'mobileNumber',
      'email',
      'organisationAddress',
    ].forEach((key, index) => {
      temp.push({
        id: index.toString(),
        label: typeMappingHandler(key).title,
        value:
          key === 'fullName' ? `${userInfo?.firstName + ' ' + userInfo.lastName}` : userInfo[key],
      });
    });

    setOrgPersonal(temp);

    setLoading(false);
  };

  useEffect(() => {
    if (user) calculateOrgPersonal(user);
  }, [user]);

  if (loading)
    return (
      <Box className='flexCenter' height='500px'>
        <CircularProgress size={26} color='primary' />
      </Box>
    );

  return (
    <Box className='mainDashboardContainer'>
      <Grid container spacing={1} mt={2}>
        <Grid item xl={3} lg={6} md={6} xs={12}>
          <ReportCard
            title='تعداد کاربران سازمان'
            value={userCount || 0}
            bgColor='#005B96'
            bgIcon='#084387'
            icon={<AccountCircleRoundedIcon color='inherit' />}
          />
        </Grid>

        <Grid item xl={3} lg={6} md={6} xs={12}>
          <ReportCard
            title='تعداد تست های خریداری شده'
            value={totalPurchasedTests || 0}
            bgColor='#CC0056'
            bgIcon='#990041'
            icon={<ReceiptLongOutlinedIcon color='inherit' />}
          />
        </Grid>

        <Grid item xl={3} lg={6} md={6} xs={12}>
          <ReportCard
            title='تعداد تست های انجام شده'
            value={totalDoneTests || 0}
            bgColor='#FE6B01'
            bgIcon='#BF5000'
            icon={<FactCheckOutlinedIcon color='inherit' />}
          />
        </Grid>

        <Grid item xl={3} lg={6} md={6} xs={12}>
          <ReportCard
            title='موجودی حساب سازمان'
            amount={amount}
            bgColor='#00CC8F'
            bgIcon='#00996B'
            icon={<AccountBalanceWalletOutlinedIcon color='inherit' />}
          />
        </Grid>
      </Grid>

      <Box className='content'>
        <Box className='header'>
          <Box className='iconContainer'>
            <AnnouncementOutlinedIcon color='primary' />
          </Box>

          <Typography className='title'>اطلاعات</Typography>
        </Box>

        <Box className='spaceBetween' p={2} gap={2}>
          <Box width='100%'>
            {orgPersonal.slice(0, 3).map((item) => (
              <Box className='row' key={item.label}>
                <Box>
                  <Box className='circle' bgcolor='primary.main' />
                  <Typography color='text.main'>{item.label}</Typography>
                </Box>
                <Typography color='text.main' noWrap fontSize='small' pr={0.5} dir='ltr'>
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          <Divider orientation='vertical' flexItem />

          <Box width='100%'>
            {orgPersonal.slice(3, 6).map((item) => (
              <Box className='row' key={item.label}>
                <Box>
                  <Box className='circle' bgcolor='primary.main' />
                  <Typography color='text.main'>{item.label}</Typography>
                </Box>
                <Typography color='text.main' noWrap fontSize='small' pr={0.5} dir='ltr'>
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
